export const hacerSolicitud = async (url, options, renovarToken, cerrarSesion, requiereToken =  true) => {
  let token = requiereToken ? localStorage.getItem('auth_token') : null;

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        ...options.headers,
        ...(requiereToken ? { 'Authorization': `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
      },
    });


    if ((response.status === 403 || response.status === 401) && requiereToken) {
      token = await renovarToken();

      if (token) {
        const retryResponse = await fetch(url, {
          ...options,
          headers: {
            ...options.headers,
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!retryResponse.ok) {
          throw new Error('Error al obtener datos después de renovar el token');
        }

        return await retryResponse.json();
      } else {
        throw new Error('No se pudo renovar el token');
      }
    }

    if (!response.ok) throw new Error('Error al obtener datos');
    return await response.json();
  } catch (err) {
    if (err.message.includes('No se pudo renovar el token') && requiereToken) {
      cerrarSesion();
    }
    throw err;
  }
};
